module.exports = __webpack_public_path__ + "img/magazine45.c87590fb.jpg";